import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, skip } from 'rxjs';
import { ApiService } from '../api/api.service';
import { LanguageService } from '../language-service/language.service';
import { WeatherDto } from './weather.interface';


@Injectable({
  providedIn: 'root'
})
export class WeatherService {
  private apiService = inject(ApiService);
  private languageService = inject(LanguageService);

  public weatherData = new BehaviorSubject<WeatherDto>(null);
  private lastCity: string;

  constructor() {
    this.languageService.selected.pipe(skip(1)).subscribe(() => {
      if (this.lastCity) {
        this.getWeatherData(this.lastCity);
      }
    });
  }

  getWeatherData(city: string): void {
    this.lastCity = city;
    this.apiService.getWeather(city, this.languageService.selected.value).subscribe(res => {
      this.weatherData.next(res);
    });
  }

} 